import React from 'react';
import { DashboardCard } from './DashboardCard';
import { TruckIcon, PackageIcon, WarehouseIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, ArrowUpIcon, ArrowDownIcon, BarChart3Icon, DollarSignIcon, FilterIcon, ArrowUpDownIcon, GlobeIcon } from 'lucide-react';
export function OrdersOverview() {
  // Mock data
  const orderStats = {
    active: 22,
    value: '$2,272,301.43',
    margin: '20.78%',
    pending: {
      approval: 4,
      acknowledgment: 11,
      stock: 0,
      readyToLoad: 0,
      loading: 0
    }
  };
  const regions = [{
    name: 'Aisco EUROPE',
    value: 17,
    max: 20,
    percentage: 85
  }, {
    name: 'Aisco AMERICA',
    value: 4,
    max: 20,
    percentage: 20
  }, {
    name: 'Aisco ANZ',
    value: 1,
    max: 20,
    percentage: 5
  }];
  const dealers = [{
    name: 'Imper Regas Lda',
    count: 5,
    amount: '$225,896.83',
    missingPart: 0,
    pending: 0
  }, {
    name: 'KOAN IRRIGATION',
    count: 3,
    amount: '$175,432.21',
    missingPart: 0,
    pending: 0
  }, {
    name: 'VK SALES & SERVICE',
    count: 3,
    amount: '$157,890.45',
    missingPart: 0,
    pending: 0
  }, {
    name: 'AQUADOC',
    count: 3,
    amount: '$142,753.68',
    missingPart: 0,
    pending: 0
  }, {
    name: 'RIEGOS Y SISTEMAS JAIME BORREGO',
    count: 2,
    amount: '$98,567.32',
    missingPart: 0,
    pending: 0
  }, {
    name: 'SRL "AGROPROFI TECH"',
    count: 1,
    amount: '$76,432.19',
    missingPart: 0,
    pending: 0
  }];
  return <div className="space-y-6" data-id="element-1849">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1850">
        <DashboardCard className="md:col-span-2" icon={<TruckIcon size={20} className="text-blue-400" data-id="element-1852" />} title="Active Orders" subtitle="Current month" data-id="element-1851">
          <div className="flex flex-col" data-id="element-1853">
            <div className="text-4xl font-bold text-white mb-4" data-id="element-1854">
              {orderStats.value}
            </div>
            <div className="text-sm text-blue-300 mb-6" data-id="element-1855">
              Average margin: {orderStats.margin}
            </div>
            <div className="flex items-center justify-between mb-4" data-id="element-1856">
              <div className="flex items-center" data-id="element-1857">
                <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mr-3" data-id="element-1858">
                  <span className="text-2xl font-bold text-blue-400" data-id="element-1859">
                    {orderStats.active}
                  </span>
                </div>
                <div className="text-sm" data-id="element-1860">
                  <div className="text-white font-medium" data-id="element-1861">Active orders</div>
                  <div className="text-blue-300" data-id="element-1862">Last updated today</div>
                </div>
              </div>
              <div className="flex items-center space-x-2" data-id="element-1863">
                <div className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-sm" data-id="element-1864">
                  This Month
                </div>
                <div className="px-3 py-1 rounded-full bg-slate-800 text-blue-300 text-sm cursor-pointer hover:bg-slate-700" data-id="element-1865">
                  Last Month
                </div>
              </div>
            </div>
            <div className="h-40 relative" data-id="element-1866">
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-2" data-id="element-1867">
                {Array.from({
                length: 12
              }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-1868">
                      <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                  height: `${Math.random() * 100 + 20}px`
                }} data-id="element-1869"></div>
                      <div className="text-xs text-blue-300 mt-1" data-id="element-1870">
                        {new Date(0, i).toLocaleString('default', {
                    month: 'short'
                  })}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<ClockIcon size={20} className="text-amber-400" data-id="element-1872" />} title="Pending Status" data-id="element-1871">
          <div className="space-y-6" data-id="element-1873">
            <div className="grid grid-cols-3 gap-4" data-id="element-1874">
              <StatusItem value={orderStats.pending.approval} label="Approval" color="amber" data-id="element-1875" />
              <StatusItem value={orderStats.pending.acknowledgment} label="Acknowledgment" color="blue" data-id="element-1876" />
              <StatusItem value={orderStats.pending.stock} label="Stock" color="emerald" data-id="element-1877" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1878">
              <StatusBox icon={<WarehouseIcon size={18} className="text-blue-300" data-id="element-1880" />} value={orderStats.pending.readyToLoad} label="Ready to load" data-id="element-1879" />
              <StatusBox icon={<TruckIcon size={18} className="text-blue-300" data-id="element-1882" />} value={orderStats.pending.loading} label="Loading" data-id="element-1881" />
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1883">
        <DashboardCard icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-1885" />} title="Regional Distribution" className="md:col-span-3" data-id="element-1884">
          <div className="space-y-4" data-id="element-1886">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1887">
                <div className="flex justify-between" data-id="element-1888">
                  <span className="text-sm text-blue-300" data-id="element-1889">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1890">
                    {region.value} orders
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1891">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1892"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-400" data-id="element-1893">
                  <span data-id="element-1894">0</span>
                  <span data-id="element-1895">{region.max}</span>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1897" />} title="Orders by Dealers" footer={<div className="flex justify-between text-sm text-blue-300" data-id="element-1898">
            <span data-id="element-1899">Showing 6 of 24 dealers</span>
            <button className="text-blue-400 hover:text-white" data-id="element-1900">View All</button>
          </div>} data-id="element-1896">
        <div className="flex justify-end mb-4" data-id="element-1901">
          <div className="flex items-center space-x-2" data-id="element-1902">
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1903">
              <ArrowUpDownIcon size={16} data-id="element-1904" />
            </button>
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1905">
              <FilterIcon size={16} data-id="element-1906" />
            </button>
            <div className="relative" data-id="element-1907">
              <select className="appearance-none bg-slate-800 text-blue-300 rounded-lg px-3 py-1.5 pr-8 text-sm border border-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1908">
                <option data-id="element-1909">Active orders</option>
                <option data-id="element-1910">All orders</option>
                <option data-id="element-1911">Completed orders</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-300" data-id="element-1912">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-1913">
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" data-id="element-1914" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1915">
          <table className="w-full" data-id="element-1916">
            <thead data-id="element-1917">
              <tr className="text-left border-b border-slate-700" data-id="element-1918">
                <th className="pb-3 font-medium text-blue-300 text-sm" data-id="element-1919">
                  Dealer
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm" data-id="element-1920">
                  Status
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm text-right" data-id="element-1921">
                  Amount
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm text-right" data-id="element-1922">
                  Count
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1923">
              {dealers.map((dealer, index) => <tr key={index} className="border-b border-slate-800/50 last:border-0 hover:bg-slate-800/30" data-id="element-1924">
                  <td className="py-3 text-white" data-id="element-1925">{dealer.name}</td>
                  <td className="py-3" data-id="element-1926">
                    {dealer.pending > 0 ? <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-500/20 text-amber-300" data-id="element-1927">
                        <AlertCircleIcon size={12} className="mr-1" data-id="element-1928" />
                        {dealer.pending} pending
                      </div> : <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-500/20 text-emerald-300" data-id="element-1929">
                        <CheckCircleIcon size={12} className="mr-1" data-id="element-1930" />
                        Approved
                      </div>}
                  </td>
                  <td className="py-3 text-right text-blue-300" data-id="element-1931">
                    {dealer.amount}
                  </td>
                  <td className="py-3 text-right" data-id="element-1932">
                    <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-500/20 text-blue-300" data-id="element-1933">
                      {dealer.count}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </DashboardCard>
    </div>;
}
function StatusItem({
  value,
  label,
  color
}) {
  const colors = {
    amber: 'text-amber-400',
    blue: 'text-blue-400',
    emerald: 'text-emerald-400'
  };
  return <div className="text-center" data-id="element-1934">
      <div className={`text-xl font-bold ${colors[color]} mb-1`} data-id="element-1935">{value}</div>
      <div className="text-xs text-blue-300" data-id="element-1936">{label}</div>
    </div>;
}
function StatusBox({
  icon,
  value,
  label
}) {
  return <div className="bg-slate-800/50 rounded-lg p-4 text-center" data-id="element-1937">
      <div className="flex justify-center mb-2" data-id="element-1938">
        <div className="p-2 rounded-lg bg-slate-700/50" data-id="element-1939">{icon}</div>
      </div>
      <div className="text-blue-300 text-xl font-bold mb-1" data-id="element-1940">{value}</div>
      <div className="text-xs text-blue-300" data-id="element-1941">{label}</div>
    </div>;
}